import { mapRecordFromServer, mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetOneResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import { IProject, IProjectDetails, IProjectQuoteAssociationCriteria } from 'projects/types';

export const getProjects = async (requestPayload?: IRequestPayload, signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get(
    `/project/list/projects?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IProject>(data?.data, data?.recordsFiltered);
};

export const getProject = async (
  requestPayload: { id: number },
  signal?: AbortSignal
): Promise<GetOneResponse<IProjectDetails>> => {
  const payload = {
    project: {
      ...requestPayload,
    },
  };

  const { data } = await partfinitiClient.get(
    `/project_v2/details/project?${getQueryStringToSnakeCase(payload)}`,
    signal
  );

  return mapRecordFromServer<IProjectDetails>(data.project);
};

export const getManyAutocomplete = async (
  requestPayload?: IRequestPayload,
  signal?: AbortSignal
) => {
  const { data } = await partfinitiClient.get(
    `/project/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IProject>(data.projects, data.total_count);
};

export const upsertProject = async (data: IProject) =>
  partfinitiClient.postForm('/project/index/save', data);

export const removeProjectQuoteAssociation = async (data: IProjectQuoteAssociationCriteria) =>
  partfinitiClient.postForm('/project_v2/quote-association-edit/remove-bulk', data);
